import { render, staticRenderFns } from "./zhiyao.vue?vue&type=template&id=120c1c0c&"
import script from "./zhiyao.vue?vue&type=script&lang=js&"
export * from "./zhiyao.vue?vue&type=script&lang=js&"
import style0 from "./zhiyao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports